const initHomeHeroHeight = () => {
	const hero = document.querySelector('.home-hero');
	const header = document.querySelector('.site-header');
	if (!hero || !header) return;
	const portrait = window.matchMedia('(max-width: 575.98px) and (orientation: portrait)');
	const update = () => {
		if (portrait.matches) hero.style.setProperty('--home-hero-header-height', `${header.getBoundingClientRect().height}px`);
		else hero.style.removeProperty('--home-hero-header-height');
	};
	new ResizeObserver(update).observe(header);
	portrait.addEventListener('change', update);
	update();
};
export default initHomeHeroHeight;
